import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=749d6994&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=749d6994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d6994",
  null
  
)

export default component.exports